export const disableEmptyParents = (nodes: any[]): any[] => {
  return nodes.map(node => {
    const nodeIsParent = node.fileType === 'folder';
    const shouldDisable = nodeIsParent && !hasSelectableDescendants(node);

    return {
      ...node,
      disabled: shouldDisable,
      children: node.children ? disableEmptyParents(node.children) : node.children
    };
  });
};

export const findItemById = (items: any[], id: string): any => {
  for (const item of items) {
    if (item.id === id) return item;
    if (item.children?.length) {
      const found = findItemById(item.children, id);
      if (found) return found;
    }
  }
  return null;
};

const hasSelectableDescendants = (node: any): boolean => {
  if (node.fileType !== 'folder') {
    return true;
  }

  if (!node.children || node.children.length === 0) {
    return false;
  }

  return node.children.some((child: any) => hasSelectableDescendants(child));
};